const api = '/api/getOtherSiteInfo.php';
import axios from 'axios';
export const otherSiteRepsitory =  {
    methods: {
        async post(item){
            return  axios.post(api,item)
        }
    }
};

